<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <!--PRUEBA para evitar que salga el autocomplete en los campos Numero y Fecha-->
    <input autocomplete="false" name="hidden" type="text" style="display:none;">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()"><i class="fa fa-chevron-left" title="Volver"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar || formInvalid" type="button" (click)="onSubmit()" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">{{editTitle}} Documento {{CodigoSolicitud}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{CodigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudEx | IconoTipoSolicitudEx}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudEx | IconoEstadoSolicitudEx}}" ngbTooltip="{{EstadoSolicitudExDescripcion}}" />
                <img *ngIf="IdSubTipoSolicitudEx === tercerPaisConAtestFito || IdSubTipoSolicitudEx === reExpConAtestFito || IdSubTipoSolicitudEx === canariasConAtestFito"
                     class="estado-icono-big" src="{{IdSubTipoSolicitudEx | IconoTwTcSubTipoSolicitudEx}}" container="body" ngbTooltip="{{IdSubTipoSolicitudExDescripcion}}" />
                <!--<img class="estado-icono-big" container="body" src="{{EsCopiaCF ? (IdEstadoCertificadoFitoEx | IconoCopiaCertificadoEx) : (IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx) }}"
    ngbTooltip="{{EstadoCertificadoFitoExDescripcion}}" />-->                
                <!--<img class="estado-icono-big" container="body" src="{{IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx}}" ngbTooltip="{{EstadoCertificadoFitoExDescripcion}}" />-->
                <img class="estado-icono-big" container="body" src="{{EsCopiaCF ? (IdEstadoCertificadoFitoEx | IconoCopiaCertificadoEx) : (IdEstadoCertificadoFitoEx | IconoEstadoCertificadoFitoEx) }}"
                     ngbTooltip="{{EstadoCertificadoFitoExDescripcion}}" />
                <img *ngIf="IdResultadoEnvioMuestrasLaboratorioEx" class="estado-icono-big" container="body" src="{{IdResultadoEnvioMuestrasLaboratorioEx | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{DescripcionIdResultadoEnvioMuestrasLaboratorioEx}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudEx}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-header">
                    </div>

                    <div class="card-body-detalle">

                        <div class="row">

                            <div class="col-md-3">
                                <label class="col-form-label required-field" for="inpDescripcion">Tipo</label>
                                <ng-select [items]="listTipoDocumentacionEx"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdTipoDocumentacionEx"
                                           loadingText="Cargando..."
                                           [loading]="!(listTipoDocumentacionEx)"
                                           [ngClass]="displayFieldCssNgSelect('IdTipoDocumentacionEx')"
                                           notFoundText="Tipo de documento no encontrado"
                                           placeholder="-- Seleccione Tipo --"
                                           clearAllText="Eliminar selección"
                                           (change)="onSelectTipoDocumentacion()">

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoDocumentacionEx','required')">
                                    Tipo documentación es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirTexto }" for="inpTexto">Número</label>
                                <input formControlName="Texto" name="Texto" title="" class="form-control" inputStyleClass="form-control" autocomplete="nope"
                                       [ngClass]="displayFieldCss('Texto')" id="inpTexto" type="text" value="" maxlength="50">

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Texto','required')">
                                    Número es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirFecha }" for="inpFecha">Fecha</label>
                                <p-calendar formControlName="Fecha" inputStyleClass="form-control" [showIcon]="true" type="search" autocomplete="nope"
                                            [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [ngClass]="displayFieldCssCal('Fecha')">
                                </p-calendar>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('Fecha','required')">
                                    Fecha es obligatoria
                                </div>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" [ngClass]="{ 'required-field' : requerirPais }" for="intEstado">País de {{ labelPais }}</label>
                                <ng-select [items]="listPais"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPais"
                                           loadingText="Cargando..."
                                           [loading]="!listPais"
                                           notFoundText="País no encontrado"
                                           placeholder="-- Seleccione un País --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdPais')">

                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPais','required')">
                                    País es obligatorio
                                </div>
                            </div>

                        </div>

                        <div *ngIf="isInspector || esGrabador" class="row">
                            <div class="form-group col-md-3">
                                <label class="col-form-label">Visible también para solicitante </label>
                                <p-toggleButton [disabled]="!habilitarVisibilidadSolicitante" class="form-control-togglebutton"
                                                formControlName="VisibleInspector" onLabel="Sí" offLabel="NO"
                                                onIcon="pi pi-check" offIcon="pi pi-times" id=""></p-toggleButton>
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group col-md-12">
                                <label class="col-form-label required-field" for="intEstado">Documento</label>
                                <app-document-uploader [parentForm]="form" [parentSubmitted]="submitted" [readOnly]="!habilitarGuardar " [uploadedFile]="uploadedFile" [megaSizeLimit]="megaSizeLimit" (fileUploaded)="onFileUploaded($event)" (fileDeleted)="onFileDeleted($event)"></app-document-uploader>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</form>
